// Twitch enforces a maximum of 500 characters per chat message
export const TWITCH_MAX_MESSAGE_LENGTH = 500
